var map = {
	"./aston-martin-logo.png": 75959,
	"./audi-logo.png": 34109,
	"./bentley-logo.png": 87345,
	"./bike-aprilia-logo.png": 2822,
	"./bike-bajaj-logo.png": 77774,
	"./bike-benelli-logo.png": 39467,
	"./bike-bmw-logo.png": 15074,
	"./bike-ducati-logo.png": 9026,
	"./bike-fb-mondial-logo.png": 25719,
	"./bike-harley-davidson-logo.png": 15388,
	"./bike-hero-logo.png": 34046,
	"./bike-honda-logo.png": 76830,
	"./bike-husqvarna-logo.png": 43709,
	"./bike-hyosung-logo.png": 49743,
	"./bike-indian-logo.png": 13093,
	"./bike-jawa-logo.png": 34279,
	"./bike-kawasaki-logo.png": 94278,
	"./bike-ktm-logo.png": 68618,
	"./bike-mahindra-logo.png": 77032,
	"./bike-royal-enfield-logo.png": 38579,
	"./bike-suzuki-logo.png": 35999,
	"./bike-triumph-logo.png": 47211,
	"./bike-tvs-logo.png": 50051,
	"./bike-um-logo.png": 21860,
	"./bike-vespa-logo.png": 58073,
	"./bike-yamaha-logo.png": 24609,
	"./bike-yezdi-logo.png": 34763,
	"./bmw-logo.png": 33872,
	"./byd-logo.webp": 67633,
	"./chevrolet-logo.webp": 37744,
	"./citroen-logo.png": 97910,
	"./daewoo-logo.webp": 80243,
	"./datsun-logo.webp": 42911,
	"./ferrari-logo.png": 53363,
	"./fiat-logo.png": 27768,
	"./force-logo.webp": 92089,
	"./ford-logo.png": 44417,
	"./foton-logo.webp": 99748,
	"./hindustan-logo.webp": 32864,
	"./honda-logo.png": 27788,
	"./hummer-logo.png": 95238,
	"./hyundai-logo.png": 29384,
	"./isuzu-logo.webp": 28746,
	"./jaguar-logo.png": 39234,
	"./jeep-logo.png": 68328,
	"./kia-logo.png": 13121,
	"./lamborghini-logo.png": 56502,
	"./land-rover-logo.webp": 56908,
	"./lexus-logo.png": 81847,
	"./mahindra-logo.webp": 57886,
	"./maruti-suzuki-logo.png": 19584,
	"./maserati-logo.png": 99032,
	"./mercedes-logo.png": 94148,
	"./mg-logo.webp": 5528,
	"./mini-logo.png": 86279,
	"./mitsubishi-logo.png": 23567,
	"./nissan-logo.png": 52416,
	"./opel-logo.webp": 10834,
	"./photon-logo.png": 23858,
	"./porsche-logo.png": 8454,
	"./renault-logo.webp": 81497,
	"./rolls-royce-logo.png": 28537,
	"./skoda-logo.webp": 87436,
	"./ssangyong-logo.webp": 63187,
	"./tata-logo.webp": 54208,
	"./toyota-logo.png": 14054,
	"./volkswagen-logo.png": 52075,
	"./volvo-logo.png": 80204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63888;